import { defineStore } from "pinia";
import { apiGetMe } from "@/api/me";
import type { Account, GlobalPermissions, MeUser } from "@/types/account";

interface AuthState {
  initialised: boolean;
  user: MeUser | null;
  globalPermissions: GlobalPermissions | null;
  accessibleAccounts: Account[];
}

export const useAuthStore = defineStore("auth", {
  state: (): AuthState => ({
    initialised: false,
    user: null,
    globalPermissions: null,
    accessibleAccounts: [],
  }),
  getters: {
    isAuthenticated: (s) => !!s.user,
  },
  actions: {
    async init(): Promise<boolean> {
      try {
        const me = await apiGetMe();
        this.user = me.user;
        this.globalPermissions = me.globalPermissions;
        this.accessibleAccounts = me.accounts;
        this.initialised = true;
        return true;
      } catch {
        return false;
      }
    },
    reset() {
      this.$reset();
    },
  },
});
